import { wishlistApi } from '@/api'

const state = {
  items: [],
  ids: new Set(),
  loading: false,
}

const getters = {
  wishlistItems: (s) => s.items,
  isWishlisted: (s) => (itemId) => s.ids.has(itemId),
  wishlistCount: (s) => s.items.length,
}

const mutations = {
  SET_WISHLIST(state, items) {
    state.items = items || []
    state.ids = new Set((items || []).map((w) => w.item_id))
  },
  SET_LOADING(state, val) { state.loading = val },
}

const actions = {
  async fetch({ commit }) {
    if (!localStorage.getItem('token')) return
    commit('SET_LOADING', true)
    try {
      const { data } = await wishlistApi.get()
      commit('SET_WISHLIST', data)
    } catch (_) {
      commit('SET_WISHLIST', [])
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async toggle({ dispatch }, itemId) {
    await wishlistApi.toggle(itemId)
    await dispatch('fetch')
  },
}

export default { namespaced: true, state, getters, mutations, actions }
